export default "__VITE_ASSET__BkRPpWYZ__"